import React from "react";
import { Button, SearchField, Grid } from '@aws-amplify/ui-react';

export default function CreateAndSeacrh({ tokens, handleObjectPageToForm, searchTerm, handleSearch, handleClearSearch, valuePage}) {

  return (
    <Grid
    templateColumns="auto 1fr" // La primera columna se ajusta al tamaño del botón, la segunda se extiende
    gap={tokens.space.small}
    alignItems="center" 
            >
                <Button
                    variation="primary"
                    colorTheme="success"
                    onClick={handleObjectPageToForm}
                    className='button-create'
                    // style={{
                    //     height: '3rem',         // Fija la altura del botón
                    //     display: 'flex',
                    //     alignItems: 'center',   // Alinea el contenido dentro del botón verticalmente
                    //     justifyContent: 'center', // Alinea el contenido dentro del botón horizontalmente
                    // }}
                >
                    {valuePage}
                </Button>
                <SearchField
                    label="Buscar"
                    placeholder="Buscar aquí..."
                    value={searchTerm}
                    onChange={handleSearch}
                    // onSubmit={handleSearchSubmit}
                    onClear={handleClearSearch}
                    inputStyles={{
                        // height: '3rem',          // Fija la altura del campo de búsqueda para que coincida con el botón
                        // display: 'flex',
                        alignItems: 'center',    // Centra verticalmente el contenido del input
                        border: `1px solid ${tokens.colors.neutral[40]}`,  // Un pequeño borde para que sea visible
                        backgroundColor: tokens.colors.primary[60],
                        color: tokens.colors.black
                    }}
                />
            </Grid>
  );
}